class HighScoreHandler {
    
    constructor(browserDataStorge) {
        this.browserDataStorage = browserDataStorge;
    }

    getHighScore(key) {
        return Number(this.browserDataStorage.get(key));
    }

    setHighScore(key, score) {
        if (score <= this.getHighScore(key))
            return; 

        this.browserDataStorage.set(key, score);
    }
}

export default HighScoreHandler;


// WEBPACK FOOTER //
// ./src/utils/highScoreHandler.js